import * as S from "./styles.ts";

export interface IVideoFrameProps {
  src: string;
  small?: boolean;
}

const VideoFrame = ({ src, small }: IVideoFrameProps) => {
  return (
    <S.VideoFrameContainer $small={small}>
      <iframe
        width="100%"
        height="100%"
        src={src}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </S.VideoFrameContainer>
  );
};

export default VideoFrame;
